import React from 'react'
import { Redirect, Route, Switch } from 'react-router'

import TicketsList from './TicketsList'

export default function Tickets(props) {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/solicitudes" component={TicketsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}